module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('backhaul-table', {
    attrs: {
      "site-id": _vm.site.id,
      "provider": true,
      "read-only": _vm.readOnly,
      "site-name": _vm.site.siteName,
      "site-data": _vm.site
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39f34e4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/SiteBackhaul.vue
// module id = 1512
// module chunks = 0